module.exports = __webpack_public_path__ + "static/image/logo-family/logo_kitchen@3x.png?9c8c5ce4";